import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/theme-toggle";
import { ScrollLink } from "@/components/ui/scroll-link";
import { BitcoinLogo } from "@/components/icons/bitcoin-logo";

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <ScrollLink to="/" className="flex items-center gap-2">
          <div className="rounded-full">
            <BitcoinLogo className="h-8 w-8" />
          </div>
          <span className="font-display font-bold text-xl">Bitcoiner Books</span>
        </ScrollLink>
        <nav className="flex items-center space-x-2">
          <Button variant="ghost" asChild>
            <ScrollLink to="/books">Books</ScrollLink>
          </Button>
          <Button variant="ghost" asChild>
            <ScrollLink to="/authors">Authors</ScrollLink>
          </Button>
          <Button variant="ghost" asChild>
            <ScrollLink to="/people">People</ScrollLink>
          </Button>
          <ThemeToggle />
        </nav>
      </div>
    </header>
  );
}